require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 618
// module chunks = 0